<div class="empty" [@inOutAnimation]>
  <h2 class="empty__title">{{ "APP.TABLES.EMPTY_STATE.TITLE" | translate }}</h2>
</div>
